import dao from '../../../dao/configDao';
import globals from '../../../utils/config/globals';
import _ from 'lodash';
import subscriptionUtils from '../../../utils/subscriptionUtils';

const GET_CONFIGURATION = 'pages/webmodule/configuration/GET_CONFIGURATION';
const GET_CONFIGURATION_SUCCESS =
  'pages/webmodule/configuration/GET_CONFIGURATION_SUCCESS';
const UPDATE_CONFIGURATION =
  'pages/webmodule/configuration/UPDATE_CONFIGURATION';
const UPDATE_CONFIGURATION_SUCCESS =
  'pages/webmodule/configuration/UPDATE_CONFIGURATION_SUCCESS';
const UPDATE_CONFIGURATION_FAILED =
  'pages/webmodule/configuration/UPDATE_CONFIGURATION_FAILED';
const SWITCH_MODULE_LAYOUT_DEVICE =
  'smb/components/webmodule/configuration/SWITCH_MODULE_LAYOUT_DEVICE';
const RESET = 'smb/components/webmodule/configuration/RESET';
const RESTORE_DESKTOP_LAYOUT =
  'smb/components/webmodule/configuration/RESTORE_DESKTOP_LAYOUT';
const RESTORE_MOBILE_LAYOUT =
  'smb/components/webmodule/configuration/RESTORE_MOBILE_LAYOUT';
const RESTORE_ADVANCE =
  'smb/components/webmodule/configuration/RESTORE_ADVANCE';

const OPEN_CUSTOM_BACKGROUND_DIALOG =
  'smb/components/webmodule/configuration/OPEN_CUSTOM_BACKGROUND_DIALOG';

const CLOSE_CUSTOM_BACKGROUND_DIALOG =
  'smb/components/webmodule/configuration/CLOSE_CUSTOM_BACKGROUND_DIALOG';

const OPEN_CHECK_TAB_SWITCH_DIALOG =
  'smb/components/webmodule/configuration/OPEN_CHECK_TAB_SWITCH_DIALOG';

const CLOSE_CHECK_TAB_SWITCH_DIALOG =
  'smb/components/webmodule/configuration/CLOSE_CHECK_TAB_SWITCH_DIALOG';

const USE_DEFAULT_LAYOUT =
  'smb/components/webmodule/configuration/USE_DEFAULT_LAYOUT';

const USE_CUSTOM_LAYOUT =
  'smb/components/webmodule/configuration/USE_CUSTOM_LAYOUT';

const SET_CURRENT_TAB_KEY =
  'smb/components/webmodule/configuration/SET_CURRENT_TAB_KEY';

const SET_SELECTED_TAB_KEY =
  'smb/components/webmodule/configuration/SET_SELECTED_TAB_KEY';

const SET_CONFIG_DIRTY_STATUS =
  'smb/components/webmodule/configuration/SET_CONFIG_DIRTY_STATUS';

const initialState = {
  isDesktop: true,
  isLoaded: true,
  useDefaultLayout: false,
  isOpeCustomBackgroundDialog: false,
  isOpenCheckTabSwitchDialog: false,
  currentTabKey: 'D',
  selectedTabKey: 'D',
  configDirtyStatus: false,
  allConfig: {
    domain: 'your-domain.com',
    layout: globals.layouts[0].value,
    resolutionDesktop: globals.resolutions[5].value,
    resolutionMobile: globals.mobileResolutions[1].value,
    backgroundDesktop: {
      platform: 'DESKTOP',
      fileType: 'BACKGROUND',
      imageUrl: globals.layouts[0].imageUrl,
      image: '',
    },
    backgroundMobile: {
      platform: 'MOBILE',
      fileType: 'BACKGROUND',
      imageUrl: globals.layouts[0].imageUrl,
      image: '',
    },
    watermarkDesktop: {
      platform: 'DESKTOP',
      fileType: 'WATERMARK',
      imageUrl: '',
      image: '',
    },
    watermarkMobile: {
      platform: 'MOBILE',
      fileType: 'WATERMARK',
      imageUrl: '',
      image: '',
    },
    modelPhotoDesktop: [
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image1.jpg',
        image: '',
      },
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image2.jpg',
        image: '',
      },
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image3.jpg',
        image: '',
      },
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image4.jpg',
        image: '',
      },
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image5.jpg',
        image: '',
      },
      {
        platform: 'DESKTOP',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image6.jpg',
        image: '',
      },
    ],
    modelPhotoMobile: [
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image1.jpg',
        image: '',
      },
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image2.jpg',
        image: '',
      },
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image3.jpg',
        image: '',
      },
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image4.jpg',
        image: '',
      },
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image5.jpg',
        image: '',
      },
      {
        platform: 'MOBILE',
        fileType: 'MODEL',
        imageUrl:
          'https://plugins-media.makeupar.com/webconsultation/images/makeup/image6.jpg',
        image: '',
      },
    ],
    attrs: {
      'layout-model-photos': true,
      'behavior-2-color-photo-comparison': false,
      'social-email': true,
      'social-facebook': true,
      'social-pinterest': false,
      'social-twitter': false,
      'social-weibo': false,
      'layout-language': 'enu',
      'layout-floating-icon-on-right': false,
      'behavior-expand-module-on-open': false,
    },
  },
};

const initialState4MakeupEssential = {
  attrs: {
    'enabled-categories':
      '["BLUSH","EYELINER","EYESHADOW","LIPCOLOR","FOUNDATION","MASCARA","EYELASHES"]',
  },
};

const initialState4MakeupPremium = {
  attrs: {
    'enabled-categories':
      '["BLUSH","EYELINER","EYESHADOW","LIPCOLOR","FOUNDATION","MASCARA","EYELASHES"]',
  },
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case RESET:
      return {
        ...initialState,
        allConfig: {
          ...initialState.allConfig,
          attrs: {...initialState.allConfig.attrs, ...action.payload.attrs},
        },
      };
    case SWITCH_MODULE_LAYOUT_DEVICE:
      return {...state, isDesktop: action.isDesktop};
    case GET_CONFIGURATION:
      return {
        ...state,
        isLoaded: false,
      };
    case GET_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoaded: true,
        allConfig: action.json,
      };
    case UPDATE_CONFIGURATION:
      return {
        ...state,
      };
    case UPDATE_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isLoaded: true,
      };
    case UPDATE_CONFIGURATION_FAILED:
      return {
        ...state,
        isLoaded: true,
      };
    case RESTORE_DESKTOP_LAYOUT:
      let desktopLayoutConfig = Object.assign({}, state.allConfig);
      desktopLayoutConfig.layout = initialState.allConfig.layout;
      desktopLayoutConfig.resolutionDesktop =
        initialState.allConfig.resolutionDesktop;
      desktopLayoutConfig.watermarkDesktop =
        initialState.allConfig.watermarkDesktop;
      desktopLayoutConfig.modelPhotoDesktop =
        initialState.allConfig.modelPhotoDesktop;
      desktopLayoutConfig.backgroundDesktop =
        initialState.allConfig.backgroundDesktop;
      return {
        ...state,
        isLoaded: false,
        allConfig: desktopLayoutConfig,
      };
    case RESTORE_MOBILE_LAYOUT:
      let mobileLayoutConfig = Object.assign({}, state.allConfig);
      mobileLayoutConfig.layout = initialState.allConfig.layout;
      mobileLayoutConfig.resolutionMobile =
        initialState.allConfig.resolutionMobile;
      mobileLayoutConfig.watermarkMobile =
        initialState.allConfig.watermarkMobile;
      mobileLayoutConfig.backgroundMobile =
        initialState.allConfig.backgroundMobile;
      mobileLayoutConfig.modelPhotoMobile =
        initialState.allConfig.modelPhotoMobile;
      return {
        ...state,
        isLoaded: false,
        allConfig: mobileLayoutConfig,
      };
    case RESTORE_ADVANCE:
      let advanceConfig = Object.assign({}, state.allConfig);
      advanceConfig.attrs = initialState.allConfig.attrs;
      return {
        ...state,
        isLoaded: false,
        allConfig: advanceConfig,
      };
    case OPEN_CUSTOM_BACKGROUND_DIALOG: {
      return {
        ...state,
        isOpeCustomBackgroundDialog: true,
      };
    }
    case CLOSE_CUSTOM_BACKGROUND_DIALOG: {
      return {
        ...state,
        isOpeCustomBackgroundDialog: false,
      };
    }
    case OPEN_CHECK_TAB_SWITCH_DIALOG: {
      return {
        ...state,
        isOpenCheckTabSwitchDialog: true,
      };
    }
    case CLOSE_CHECK_TAB_SWITCH_DIALOG: {
      return {
        ...state,
        isOpenCheckTabSwitchDialog: false,
      };
    }

    case USE_DEFAULT_LAYOUT:
      return {
        ...state,
        useDefaultLayout: true,
      };
    case USE_CUSTOM_LAYOUT:
      return {
        ...state,
        useDefaultLayout: false,
      };

    case SET_SELECTED_TAB_KEY:
      return {
        ...state,
        selectedTabKey: action.tabKey,
      };
    case SET_CURRENT_TAB_KEY:
      return {
        ...state,
        currentTabKey: action.tabKey,
      };
    case SET_CONFIG_DIRTY_STATUS:
      return {
        ...state,
        configDirtyStatus: action.status,
      };
    default:
      return state;
  }
};

export function reset() {
  return (dispatch, getState) => {
    return dispatch({
      type: RESET,
      payload: getCompleteConfig(
        getState().pages.webmodule.configuration.allConfig,
        getState().components.auth.accountSummary
      ),
    });
  };
}

export function getConfiguration() {
  return (dispatch, getState) => {
    dispatch({
      type: GET_CONFIGURATION,
    });
    return dao
      .queryConfig()
      .then(json =>
        dispatch(
          getConfigurationSuccess(
            json,
            getState().components.auth.accountSummary
          )
        )
      );
  };
}

function getConfigurationSuccess(json, accountSummary) {
  if (_.isEmpty(json)) {
    json = getCompleteConfig(initialState.allConfig, accountSummary);
  }
  return {
    type: GET_CONFIGURATION_SUCCESS,
    json,
  };
}

export function switchDeviceToDesktop() {
  return {
    type: SWITCH_MODULE_LAYOUT_DEVICE,
    isDesktop: true,
  };
}

export function switchDeviceToMobile() {
  return {
    type: SWITCH_MODULE_LAYOUT_DEVICE,
    isDesktop: false,
  };
}

export function updateConfiguration(newConfig) {
  return dispatch => {
    dispatch({
      type: UPDATE_CONFIGURATION,
    });
    return dao.updateConfig(newConfig).then(r => {
      if ('errorCode' in r) {
        dispatch({
          type: UPDATE_CONFIGURATION_FAILED,
        });
      } else {
        dispatch({
          type: UPDATE_CONFIGURATION_SUCCESS,
        });
      }
      dispatch(getConfiguration());
      return r;
    });
  };
}

export function restoreDesktopLayout() {
  return (dispatch, getState) => {
    dispatch({
      type: RESTORE_DESKTOP_LAYOUT,
    });
    const config = getState().pages.webmodule.configuration.allConfig;
    return dao.updateConfig(config).then(r => {
      if ('errorCode' in r) {
        dispatch({
          type: UPDATE_CONFIGURATION_FAILED,
        });
      } else {
        dispatch({
          type: UPDATE_CONFIGURATION_SUCCESS,
        });
      }
      dispatch(getConfiguration());
      return r;
    });
  };
}

export function restoreMobileLayout() {
  return (dispatch, getState) => {
    dispatch({
      type: RESTORE_MOBILE_LAYOUT,
    });
    const config = getState().pages.webmodule.configuration.allConfig;
    return dao.updateConfig(config).then(r => {
      if ('errorCode' in r) {
        dispatch({
          type: UPDATE_CONFIGURATION_FAILED,
        });
      } else {
        dispatch({
          type: UPDATE_CONFIGURATION_SUCCESS,
        });
      }
      dispatch(getConfiguration());
      return r;
    });
  };
}

export function restoreAdvance() {
  return (dispatch, getState) => {
    dispatch({
      type: RESTORE_ADVANCE,
    });
    const config = getState().pages.webmodule.configuration.allConfig;

    const completeConfig = getCompleteConfig(
      config,
      getState().components.auth.accountSummary
    );

    return dao.updateConfig(completeConfig).then(r => {
      if ('errorCode' in r) {
        dispatch({
          type: UPDATE_CONFIGURATION_FAILED,
        });
      } else {
        dispatch({
          type: UPDATE_CONFIGURATION_SUCCESS,
        });
      }
      dispatch(getConfiguration());
      return r;
    });
  };
}

export function openCustomBackgroundDialog() {
  return {
    type: OPEN_CUSTOM_BACKGROUND_DIALOG,
  };
}

export function closeCustomBackgroundDialog() {
  return {
    type: CLOSE_CUSTOM_BACKGROUND_DIALOG,
  };
}

export function chooseDefaultLayout() {
  return {
    type: USE_DEFAULT_LAYOUT,
  };
}
export function chooseCustomLayout() {
  return {
    type: USE_CUSTOM_LAYOUT,
  };
}

export function openCheckTabSwitchDialog() {
  return {
    type: OPEN_CHECK_TAB_SWITCH_DIALOG,
  };
}

export function closeCheckTabSwitchDialog() {
  return {
    type: CLOSE_CHECK_TAB_SWITCH_DIALOG,
  };
}

export function setCurrentTabKey(tabKey) {
  return {
    type: SET_CURRENT_TAB_KEY,
    tabKey: tabKey,
  };
}

export function setSelectedTabKey(tabKey) {
  return {
    type: SET_SELECTED_TAB_KEY,
    tabKey: tabKey,
  };
}
export function setConfigDirtyStatus(status) {
  return {
    type: SET_CONFIG_DIRTY_STATUS,
    status: status,
  };
}

export function getCompleteConfig(currentConfig, accountSummary) {
  const functionType = accountSummary.customer.functionType;
  const isPremium = subscriptionUtils.isPremiumPlan(accountSummary);

  if (functionType === 'EYEWEAR') {
    return currentConfig;
  }

  const initialStateAttrs = isPremium
    ? initialState4MakeupPremium.attrs
    : initialState4MakeupEssential.attrs;

  return {
    ...currentConfig,
    attrs: {
      ...currentConfig.attrs,
      ...initialStateAttrs,
    },
  };
}
